import React from "react";
import CombustivelService from "../../services/CombustivelService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaCombustivel extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: CombustivelService,
            labels: {
                title: 'Lista de Combustível(s)',
                btnNewRegister: 'Combustível',
            },
            keyItem: 'idCombustivel',
            urlForm: '/CadCombustivel',
            itensFilter: ["idCombustivel", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idCombustivel}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}